import {
  getDate,
  getHours,
  getMinutes,
  getMonth,
  getSeconds,
  getYear,
} from 'date-fns'

const formatWithLeadingZero = (val: number) =>
  val < 10 ? `0${val}` : val.toString()

export default function (date: Date) {
  const year = getYear(date)
  // If the values are less than 10, we have to prepend a 0
  // otherwise Contentful doesn't read the date correctly
  const month = formatWithLeadingZero(getMonth(date) + 1) // 0 index month of year
  const day = formatWithLeadingZero(getDate(date)) // Day of month, i.e. 29
  const hours = formatWithLeadingZero(getHours(date))
  const minutes = formatWithLeadingZero(getMinutes(date))
  const seconds = formatWithLeadingZero(getSeconds(date))
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z` as `${number}-${number}-${number}T${number}:${number}:${number}Z`
}
